import { adjustContentVisibility, Section } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import bottomCTALottieData from '@/static/assets/renters/bottom_cta.json';
import { PRODUCT_HOME_US_RENTERS } from '@/utils/products';
import { Flex, useLottie } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import type React from 'react';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Subtitle, Title } from './shared/ContentStyling';

const BottomCTAContainer = styled(Section)`
  text-align: center;
  position: relative;
  ${adjustContentVisibility}
`;

const JoinCTAStyled = styled(JoinCTA)`
  ${MEDIA_QUERIES.mobile`
      margin-top: 20px;
  `}
`;

const Band = styled.div`
  position: absolute;
  bottom: -2px;
  width: 100%;
  height: 83px;
  background: ${t => t.theme.colors.cloud};
  z-index: -2;
`;

export interface BottomCTAProps {
  title?: string;
  subtitle?: string;
  ctaLabel?: string;
  ctaUrl?: string;
  // lottie animation config
  animationConfig?: unknown;
}

export const BottomCTA: React.FC<BottomCTAProps> = ({
  title = 'Starting from $5/mo. <br /> (not a typo)',
  subtitle = 'Safeguard all your stuff with just a few taps.',
  ctaUrl,
  ctaLabel = 'Check our prices',
  animationConfig,
}) => {
  const lottieRef = useRef<Element>(null);

  const ctaLottie = useLottie(lottieRef, {
    animationData: animationConfig ?? bottomCTALottieData,
    lottieConfig: {
      loop: true,
    },
  });

  useEffect(() => {
    if (ctaLottie) {
      ctaLottie.play();
    }
  }, [ctaLottie]);

  return (
    <BottomCTAContainer pt={[40, 70]} width="100%" alignItems="center" flexDirection="column" zIndex={1} px={10}>
      <Title tabIndex={0}>{parse(title)}</Title>
      <Subtitle mt={20} mb={20} tabIndex={0}>
        {parse(subtitle)}
      </Subtitle>

      <JoinCTAStyled
        size="big"
        flavor="primary"
        glowing
        data-source="renters"
        product={PRODUCT_HOME_US_RENTERS}
        minWidth={233}
        customUrl={ctaUrl}
        data-position="bottom"
      >
        {ctaLabel}
      </JoinCTAStyled>
      <Flex
        ref={lottieRef}
        width={[1583, 1979, 1979, 1979]}
        height={[440, 551, 551, 551]}
        position="relative"
        zIndex={-1}
        right={[25, 0, 0, 0]}
        mt={[-90, 0, 0]}
      />
      <Band />
    </BottomCTAContainer>
  );
};
